export default "__VITE_ASSET__Bvw_6jFh__"